<template>
  <div class="PostForm media">
    <div class="media-body">
        <textarea 
          ref="postInput"
          v-model="text"
          class="form-control" 
          placeholder="Write your post" />
    </div>
    <button 
      class="PostForm__submit btn btn-primary  btn-sm pull-right"
      @click="saveModel()">Save Post</button>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    baseModel: {
      type: Object,
      default: null
    }, 
    autofocus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      text: ''
    };
  },
  computed: {
    ...mapState([
      'userId'
    ])
  },
  mounted() {
    if (this.baseModel) {
      this.text = this.baseModel.text;
    }

    if (this.autofocus) {
      this.$refs.postInput.focus();
    }
  },
  methods: {
    saveModel() {
      const isValidPost = !!this.text.trim();
      if (isValidPost) {
        const post = this.baseModel || this.createEmptyPostModel()
        post.text = this.text;
        this.$emit('submitPost', post);

        this.text = '';
      }
    },
    createEmptyPostModel() {
      return {
        date: (new Date()).toISOString(),
        user: this.userId,
        userEmail: window.fbUser.email
      };
    }
  }
}
</script>
<style>
.PostForm__submit {
  margin-left: 20px; 
}
</style>
